/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import RespuestaForm from './RespuestaForm';
import * as validations from '../../validations/validations';
import * as respuestaActions from '../../actions/respuestaActions';

import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';

class ManageRespuestaForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			respuesta:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;
        let pageInfo={ 
            page:'respuesta', 
            idioma:this.props.idioma     
        }; 
   this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        if(id && id>0 ){
            
           this.props.respuestaActions.getRespuesta(id, this.props.user).then( respuesta=>{
               this.setState({"respuesta":respuesta});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        
		
    }
    

    handleChange=(event, data)=> {

        let respuesta = this.state.respuesta;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		respuesta[field[0]]= value;
		else{
             if(!respuesta[field[0]]){
                    respuesta[field[0]]={}
                }
			respuesta[field[0]][field[1]]= value;
		}
        
		
        this.setState({"respuesta": respuesta});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let respuesta=this.state.respuesta;
              
        if(!validations.requerido(respuesta.idPregunta)){
            errors.idPregunta=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(respuesta.value)){
            errors.value=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(respuesta.texto1)){
            errors.texto1=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(respuesta.texto2)){
            errors.texto2=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.respuestaActions.save(this.state.respuesta, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.history.push('/respuestas');
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <RespuestaForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.respuesta}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    let id = ownProps.match.params.id;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        id,
        showSidebarIzquierda: state.showSidebarIzquierda,
  sidebarIzquierda: state.sidebarIzquierda, 
         color:state.color,
user:state.user, 
idioma:state.idioma,
        form:state.form
    }

}

function mapDispatchToProps(dispatch){

	return {   
 showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
         paginaActions: bindActionCreators(paginaActions, dispatch),
                 respuestaActions: bindActionCreators(respuestaActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageRespuestaForm);